"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    HotelFilterComponent: ()=>HotelFilterComponent,
    amenitiesMap: ()=>amenitiesMap
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const useChatMessagesContext_js_namespaceObject = require("../hooks/useChatMessagesContext.js");
const amenitiesMap = {
    HEALTHSVCS: 'Health Services',
    HANDFAC: 'Handicap-accessible Facilities',
    FAMFRIEND: 'Family Friendly',
    FPRKING: 'Free Parking',
    FINTRNT: 'Free Internet',
    NSMKFAC: 'Non-smoking Facilities',
    SPOOL: 'Swimming Pool',
    SUSTAIN: 'Sustainable Practices',
    KIDFRIEND: 'Kid Friendly',
    PETALLOW: 'Pets Allowed',
    RESTRNT: 'Restaurant',
    FBRKFST: 'Free Breakfast',
    FITSPA: 'Fitness Center',
    HOTTUB: 'Hot Tub',
    SPA: 'Spa Services',
    BUSCNTR: 'Business Center',
    SPOOLOUT: 'Outdoor Swimming Pool',
    FINTRRM: 'Free In-room Internet',
    FINTRPUB: 'Free Public Internet',
    KITCHEN: 'Kitchen Facilities',
    BCHFRNT: 'Beachfront Location',
    CASINO: 'Casino',
    FAIRSHUTTL: 'Airport Shuttle (fee)',
    AIRSHUTTL: 'Airport Shuttle',
    SPOOLIN: 'Indoor Swimming Pool',
    ADULTONLY: 'Adult Only Property',
    FINTRAVL: 'Free Internet in Common Areas',
    INCLUSIVE: 'All-Inclusive Option'
};
const formatFilterList = (filters = [])=>{
    if (0 === filters.length) return '';
    {
        if (1 === filters.length) return filters[0];
        const lastFilter = filters.pop();
        return `${filters.join(', ')}, and ${lastFilter}`;
    }
};
const HotelFilterComponent = (props)=>{
    const [isOpen, setIsOpen] = external_react_default().useState(false);
    const [selectedAmenities, setSelectedAmenities] = external_react_default().useState({});
    const [prevSelectedAmenities, setPrevSelectedAmenities] = external_react_default().useState({});
    const searchUrl = props?.clientRedirectUrl || '';
    const amenities = props?.args?.amenities || '';
    const { chatMessages } = (0, useChatMessagesContext_js_namespaceObject.useChatMessagesContext)();
    (0, external_react_namespaceObject.useEffect)(()=>{
        const prevSelected = amenities?.split(',').reduce((res, key)=>{
            res[key] = true;
            return res;
        }, {});
        setSelectedAmenities(prevSelected);
        setPrevSelectedAmenities(prevSelected);
    }, [
        amenities
    ]);
    const { setChatMessages, submitMessages, searchResult, hasSopqHotel, hasRtlHotel, toggleOnlyExpressDealClick, displaySopqOnly } = props;
    const { tripFilterSummary, totalSize } = searchResult;
    const hotelCount = tripFilterSummary?.totalSizeFiltered || totalSize;
    const onFilterClick = function() {
        analytics_js_default().log({
            label: 'HotelSearchResult',
            message: 'ALL_HOTEL_FILTERS_LINK_CLICKED',
            ...props?.args
        });
        setIsOpen(true);
    };
    const onAllResultsLinkClick = function() {
        analytics_js_default().log({
            label: 'HotelSearchResult',
            message: 'ALL_HOTEL_RESULTS_LINK_CLICKED',
            searchUrl,
            ...props?.args
        });
        window.open(searchUrl, '_blank');
    };
    const { amenityCounts } = props.searchResult?.tripFilterSummary || {};
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Relative, {
        top: '5px',
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
            alignItems: "center",
            ml: 3,
            mb: 4,
            children: [
                amenityCounts ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                    variation: "subtle",
                    onClick: onFilterClick,
                    mr: 2,
                    size: "small",
                    children: "Filter Options"
                }) : null,
                hasSopqHotel && hasRtlHotel && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                    variation: "subtle",
                    onClick: toggleOnlyExpressDealClick,
                    mr: 2,
                    size: "small",
                    children: displaySopqOnly ? 'Show Deals' : 'Show Express Deals Only'
                }),
                searchUrl && hotelCount ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Button, {
                    variation: "subtle",
                    onClick: onAllResultsLinkClick,
                    size: "small",
                    children: [
                        "View ",
                        hotelCount,
                        " Results"
                    ]
                }) : null,
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Dialog, {
                    zIndex: 1000,
                    showCloseButton: true,
                    scrimDismiss: false,
                    open: isOpen,
                    size: "md",
                    onOpenChange: function(isOpen) {
                        if (!isOpen) setIsOpen(false);
                    },
                    borderRadius: 'xl',
                    ariaDescription: "Dialog to filter hotels",
                    ariaTitle: "Filter hotels",
                    scrimColor: "dark",
                    headerContent: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                        children: "Available Hotel Filter Options"
                    }),
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                        p: 4,
                        children: [
                            amenityCounts ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
                                children: Object.keys(amenityCounts).map((key, i)=>{
                                    const counts = amenityCounts[key];
                                    const isSelected = Boolean(selectedAmenities?.[key]);
                                    const name = `chip-${key}-${i}`;
                                    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.FilterChip, {
                                        name: name,
                                        m: 1,
                                        selected: isSelected,
                                        label: `${amenitiesMap?.[key] || key} (${counts})`,
                                        showActionIcon: isSelected,
                                        disabled: 0 === Number(counts),
                                        onClick: function() {
                                            setSelectedAmenities({
                                                ...selectedAmenities,
                                                [key]: !isSelected
                                            });
                                        }
                                    }, name);
                                })
                            }) : null,
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("br", {}),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                                        onClick: function(event) {
                                            event.preventDefault();
                                            const { addedFilters, removedFilters } = Object.keys(selectedAmenities).reduce((acc, key)=>{
                                                const amenityName = amenitiesMap?.[key] || key;
                                                if (selectedAmenities[key] && !prevSelectedAmenities[key]) acc.addedFilters.push(amenityName);
                                                if (!selectedAmenities[key] && prevSelectedAmenities[key]) acc.removedFilters.push(amenityName);
                                                return acc;
                                            }, {
                                                addedFilters: [],
                                                removedFilters: []
                                            });
                                            let content = '';
                                            if (addedFilters.length > 0) content += `Added the following filters: ${formatFilterList(addedFilters)}. `;
                                            if (removedFilters.length > 0) content += `Removed the following filters: ${formatFilterList(removedFilters)}.`;
                                            const promptMessage = {
                                                role: 'user',
                                                content: content
                                            };
                                            analytics_js_default().log({
                                                label: 'HotelSearchResult',
                                                message: 'APPLY_HOTEL_FILTERS_CLICKED',
                                                addedFilterOptions: addedFilters.join(',') || 'none',
                                                removedFilterOptions: addedFilters.join(', ') || 'none',
                                                ...props?.args
                                            });
                                            const displayMessage = {
                                                ...promptMessage,
                                                date: new Date()
                                            };
                                            setChatMessages([
                                                ...chatMessages,
                                                displayMessage
                                            ]);
                                            submitMessages(promptMessage);
                                            setIsOpen(false);
                                        },
                                        children: "Apply Filters"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
exports.HotelFilterComponent = __webpack_exports__.HotelFilterComponent;
exports.amenitiesMap = __webpack_exports__.amenitiesMap;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "HotelFilterComponent",
    "amenitiesMap"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
